import React from "react";
import Image from "next/future/image";
import TrainingAndHackathonsImg from "../../../public/img/useCases/TrainingAndHackathons.png";
import UseCasesCarousel from "./UseCasesCarosel";
import { Section4 } from "./Constants";

const TrainingAndHackathons = ({ title }) => {
  return (
    <>
      <div
        className={`${title}-root d-flex justify-content-center align-items-center flex-row px-5 px-mob  pt-4 pb-5 g-0`}
      >
        <div className={`row`}>
          <div
            className={`col-lg-6 col pb-md-3 pt-md-5 px-md-3 py-3 px-lg-3 ps-lg-5 ${title}-details-root`}
          >
            <h2 className={`${title}-title`}>
              Trainings & Hackthons
              {/* <span><Image src={Chain} alt="link" /></span> */}
            </h2>
            <div className={`${title}-text mt-1`}>
              One-stop solution for events like workshops and hackathons!
            </div>
            <div
              className={`mx-md-5 desktop-none d-flex justify-content-center align-items-center px-md-3`}
            >
              <Image
                className={`${title}-RootImageDesktop`}
                src="/img/useCases/TrainingAndHackathons.png"
                alt="TrainingAndHackathonsImg"
                width={300}
                height={200}
              />
            </div>
            <div className={`${title}-subText mt-md-4`}>
              For small events such as workshops, trainings and hackathons,
              KonfHub offers comprehensive solution:
              <ul>
                <li>
                  Branded event pages that are customizable to your needs
                </li>
                <li>
                  Collect participant registration (can be downloaded later)
                </li>
                <li>Engage participants using live quizzing</li>
                <li>
                  Collect feedback and automatically issue participation
                  certificates
                </li>
              </ul>
            </div>
          </div>
          <div
            className={`col-lg-6 mob-none col py-md-3 d-flex justify-content-center flex-column align-items-center px-md-3 ps-lg-5 pe-lg-5 py-3`}
          >
            <div
              className={`${title}-image mx-md-5 d-flex justify-content-center align-items-center px-md-3`}
            >
              <Image
                className={`${title}-RootImageDesktop`}
                src="/img/useCases/TrainingAndHackathons.png"
                alt="TrainingAndHackathonsImg"
                width={555}
                height={370}
              />
            </div>
          </div>
          <UseCasesCarousel data={Section4} />
        </div>
      </div>
      <style jsx>
        {`
          .${title}-root {
            background: #f6f9fc;
            padding: 50px 0px;
            padding-left: 105px;
            padding-right: 105px;
          }
          .${title}-root .${title}-details-root {
            padding-right: 0px;
          }
          .${title}-root .${title}-RootImageDesktop {
            max-width: 100%;
          }
          .${title}-root .${title}-details-root .${title}-title {
            font-family: "Nunito";
            font-weight: 800;
            font-size: 42px;
            line-height: 57px;
            color: #572148;
          }
          .${title}-root .${title}-details-root .${title}-text {
            font-family: "Nunito";
            font-weight: 700;
            font-size: 22px;
            line-height: 30px;
            text-align: left;
            color: #616161;
          }
          .${title}-root .${title}-details-root .${title}-subText {
            font-family: "Nunito";
            font-weight: 500;
            font-size: 18px;
            line-height: 27px;
            color: #4f4f4f;
          }
          .desktop-none {
            display: none !important;
          }
          .${title}-root .${title}-details-root .${title}-subText ul {
            margin-bottom: 0px !important;
          }
          .${title}-root .${title}-details-root .${title}-ideaRoot {
            background: #d8d8d8;
            border-radius: 6px;
          }
          .${title}-root .${title}-details-root .${title}-ideaText {
            font-family: "Nunito";
            font-weight: 500;
            font-size: 18px;
            line-height: 25px;
            color: #2c2c2c;
          }
          .${title}-image {
            margin-top: 50px;
            max-width: 100%;
          }
          /* LG screens */
          @media only screen and (max-width: 992px) {
            .mob-none {
              display: none !important;
            }
            .desktop-none {
              display: flex !important;
            }
          }
          @media screen and (max-width: 722px) {
            .${title}-root {
              padding-left: 50px;
              padding-right: 50px;
            }
          }
          @media screen and (max-width: 679px) {
            .${title}-root {
              padding-left: 30px;
              padding-right: 30px;
            }
            .${title}-root .${title}-details-root {
              padding-right: 0px;
            }
          }
          @media screen and (max-width: 480px) {
            .${title}-root {
              padding-left: 20px;
              padding-right: 20px;
              padding-top: 30px;
              padding-bottom: 0px;
            }
            .${title}-root .${title}-details-root {
              padding-right: 10px;
              display: flex;
              flex-direction: column;
              align-items: start;
            }
            .${title}-root .${title}-details-root .${title}-title {
              font-weight: 800;
              font-size: 24px;
              line-height: 33px;
            }
            .${title}-root .${title}-details-root .${title}-text {
              font-weight: 700;
              font-size: 14px;
              line-height: 19px;
              width: 80%;
            }
            .${title}-root .${title}-details-root .${title}-subText {
              font-weight: 500;
              font-size: 16px;
              line-height: 22px;
            }
            .${title}-root .${title}-details-root .${title}-ideaText {
              font-weight: 500;
              font-size: 14px;
              line-height: 19px;
            }
          }
        `}
      </style>
    </>
  );
};

export default TrainingAndHackathons;
